import { store } from '../state';
import { renderObservationPanel, initObservationPanelListeners, hideObservationPanel } from './observation-panel';
import { renderTraversePanel, hideTraversePanel } from './traverse-panel';
import { initSitePanel, renderSitePanel, hideSitePanel } from './site-panel';
import { map } from '../map';

const els = {
  sidebar: document.getElementById('sidebar') as HTMLElement,
  emptyState: document.getElementById('empty-state') as HTMLElement,
};

function openRightPanel(): void {
  els.sidebar.classList.add('open');
  const w = getComputedStyle(document.documentElement).getPropertyValue('--sidebar-width');
  document.documentElement.style.setProperty('--sidebar-offset', w);
}

function closeRightPanel(): void {
  els.sidebar.classList.remove('open');
  document.documentElement.style.setProperty('--sidebar-offset', '0px');
}

export function initMapPanel(): void {
  console.log('🔧 Инициализация панели деталей карты');
  initObservationPanelListeners();
  initSitePanel();

  // Подписка на изменения стейта для перерисовки панели
  store.subscribe(() => {
    const state = store.getState();
    
    // Показываем панель деталей только если мы на вкладке карты и что-то выбрано
//    if (state.currentView === 'map' && (state.selectedObservation || state.selectedTraverse)) {
    if (state.currentView === 'map' && (state.selectedObservation || state.selectedTraverse || state.selectedSite)) {
      // Скрываем всё сначала
      hideObservationPanel();
      hideTraversePanel();
      hideSitePanel();
      els.emptyState.style.display = 'none';

      openRightPanel();
    
      // Показываем нужное
      if (state.selectedObservation) {
        renderObservationPanel(state);
      } else if (state.selectedTraverse) {
        renderTraversePanel(state);
      } else if (state.selectedSite) {
        renderSitePanel(state);
      }
    } else {
      // Ничего не выбрано или мы не на карте
      hideObservationPanel();
      hideTraversePanel();
      hideSitePanel();
      closeRightPanel();
      els.emptyState.style.display = state.currentView === 'map' ? 'flex' : 'none';
    }
  });
  
// изменение размеров правой панели
  const resizeHandle = document.querySelector('.sidebar-resize-handle') as HTMLElement;
  let isResizing = false;
  resizeHandle.addEventListener('mousedown', (e) => {
    isResizing = true; resizeHandle.classList.add('resizing');
    document.body.style.cursor = 'col-resize'; document.body.style.userSelect = 'none'; e.preventDefault();
  });
  document.addEventListener('mousemove', (e) => {
    if (!isResizing) return;
    const newWidth = window.innerWidth - e.clientX;
    const clamped = Math.min(Math.max(newWidth, 300), 800);
    document.documentElement.style.setProperty('--sidebar-width', `${clamped}px`);
    if (store.getState().isSidebarOpen) document.documentElement.style.setProperty('--sidebar-offset', `${clamped}px`);
  });
  document.addEventListener('mouseup', () => {
    if (isResizing) {
      isResizing = false; resizeHandle.classList.remove('resizing');
      document.body.style.cursor = ''; document.body.style.userSelect = '';
      const w = getComputedStyle(document.documentElement).getPropertyValue('--sidebar-width');
      localStorage.setItem('eco-sidebar-width', w);
      setTimeout(() => map.updateSize(), 50);
    }
  });
  const savedW = localStorage.getItem('eco-sidebar-width');
  if (savedW) document.documentElement.style.setProperty('--sidebar-width', savedW);

}